var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// tslint:disable:max-line-length
// This file is generated by generateStyles script.
// Please don't edit it manually.
import * as React from "react";
import "../../less/svg/BlueCircleBtn.less";
export var BlueCircleBtn = function (props) { return (React.createElement("svg", { viewBox: "0 0 35 37.46" },
    React.createElement("defs", null),
    React.createElement("g", __assign({ id: "Layer_2" }, props, { className: "BlueCircleBtn " + props.className }),
        React.createElement("g", { id: "Buttons" },
            React.createElement("circle", { className: "cls-1", cx: 17.5, cy: 19.96, r: 17.5 }),
            React.createElement("circle", { className: "cls-2", cx: 17.5, cy: 17.5, r: 17 }),
            React.createElement("path", { className: "cls-3", d: "M17.5 1A16.5 16.5 0 1 1 1 17.5 16.52 16.52 0 0 1 17.5 1m0-1A17.5 17.5 0 1 0 35 17.5 17.51 17.51 0 0 0 17.5 0z" }),
            React.createElement("path", { className: "cls-4", d: "M15.56 4.74a15.55 15.55 0 0 1 13.69 22.93A15.55 15.55 0 1 0 3.81 10.13a15.49 15.49 0 0 1 11.75-5.39z" }),
            React.createElement("path", { className: "cls-5", d: "M19.56 30.19A15.55 15.55 0 0 1 5.94 7.12 15.54 15.54 0 1 0 31.11 25a15.47 15.47 0 0 1-11.55 5.19z" }),
            React.createElement("ellipse", { id: "glow", className: "cls-6", cx: 23.27, cy: 7.12, rx: 1.55, ry: 3.36, transform: "rotate(-65.66 23.271 7.123)" }))))); };



//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/BlueCircleBtn.tsx
// module id = 2313
// module chunks = 3